import { IsoLocale } from '@izettle/constants';

const DEFAULT_LOCALE = IsoLocale.enGB;
const mapTranslations = translations => locale => {
  const localeTranslations = translations[locale] ?? translations[DEFAULT_LOCALE];
  return key => localeTranslations[key] ?? translations["en-GB"][key];
};

export { mapTranslations };
//# sourceMappingURL=translations.js.map
